import React, { useState } from "react";
import styles from "../styles.module.scss";
import { ProgressWrapper } from "./ProgressWrapper";
import { formatPrice } from "../utils/formatters";
import { VisitRow } from "./VisitRow";
import arrowDown from "../../../../components/SVGcomponents/arrow-down.svg";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  calculateProgressNew,
  parseDateTime,
} from "../utils/progressCalculations";

dayjs.extend(customParseFormat);

interface VisitsSectionProps {
  keyword: any;
  title: string;
  pricePerUnit?: number;
  store?: string;
  totalKeyword?: {
    current: number;
    target?: number;
    total?: number;
    price: number;
  };
}

const VisitsSection: React.FC<VisitsSectionProps> = ({
  keyword,
  title,
  pricePerUnit,
  store,
  totalKeyword
}) => {
  const [isOpen, setIsOpen] = useState(false);

  let progress = 0;
  let totalProgress = 0;
  let total = 0;
  let current = 0;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let totalPrice_old = 0;
  const today = dayjs();

  const dataType = title === 'Visits' ? 'visits' : 'installs';

  if (Array.isArray(keyword)) {
    keyword.forEach((item: any) => {
      const startDate = parseDateTime(item?.date, item?.startTime);
      const endDate = parseDateTime(item?.date, item?.endTime);
      const progressValue = calculateProgressNew(startDate, endDate);
      totalProgress += isNaN(progressValue) ? 0 : progressValue;

      // Универсальный расчёт для visits/installs
      const visitValue = dataType === 'visits'
        ? Number(item.visits || item.pageViews || 0)
        : Number(item.installs || 0);
      const totalValue = Number(item.total || 0);

      total += isNaN(totalValue) ? 0 : totalValue;
      current += isNaN(visitValue) ? 0 : visitValue;

      // Старый (некорректный) расчёт: item.price — это цена за день целиком,
      // умножать её на количество нельзя
      totalPrice_old += (item.price || 0) * (isNaN(totalValue) ? 0 : totalValue);
    });

    progress = keyword.length > 0 ? Math.floor(totalProgress / keyword.length) : 0;
  }

  // Корректный displayedCount (как в клиенте)
  const progressPercentage = progress / 100;
  const displayedCount = Math.round(total * progressPercentage);

  // Старая шапка секции и тумблер "By day" — скрыты (в клиенте секция
  // рендерится без них, раскрытием управляет кнопка в шапке ключа)
  const showSectionHeader_old = false;
  const sectionHeaderBlock_old = showSectionHeader_old ? (
    <>
      <div className={styles.titleWithProgress}>
        <span>{title}</span>
        <div className={styles.progressGroup}>
          <ProgressWrapper
            value={progress}
            status={progress === 100 ? "DONE" : "INPROGRESS"}
          />
          <span className={styles.count}>
            {isNaN(displayedCount) ? 0 : displayedCount}/{isNaN(total) ? 0 : total}
          </span>
          <span className={styles.price}>
            {formatPrice(totalKeyword?.price || 0)}
          </span>
        </div>
      </div>

      <div className={styles.byDayToggle} onClick={() => setIsOpen(!isOpen)}>
        <span>By day</span>
        <img
          src={arrowDown}
          alt="Toggle visits"
          className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ""}`}
        />
      </div>
    </>
  ) : null;

  // Без MUI Table: TableContainer даёт overflow-x auto (горизонтальный скролл),
  // а грид-строки внутри tbody разъезжаются с шапкой по колонкам
  return (
    <div className={styles.section}>
      {sectionHeaderBlock_old}

      <div>
        {Array.isArray(keyword) && keyword.length > 0 ? (
          keyword.map((visit: any, index: number) => (
            <VisitRow
              key={"visit-row" + index}
              visit={visit}
              date={visit.date}
              keywordStatus={visit?.status}
              orderType={"FIXED"}
              dataType={dataType}
              pricePerUnit={pricePerUnit}
            />
          ))
        ) : (
          <div className={styles.noDataCell}>No visit data available</div>
        )}
      </div>
    </div>
  );
};

export default VisitsSection;
